module.exports = __webpack_public_path__ + "officialStatic/img/new29.cecce44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new29.jpg
// module id = Vj4s
// module chunks = 0